export default "__VITE_ASSET__fc030dec__"